export default () => {
    if (process.env.NODE_ENV === 'development' && process.env.HOST_URL) {
        return process.env.HOST_URL
    }
    return window.location.origin
}